
import { Component, Vue } from 'vue-property-decorator'
import { getPlatforms, getMediaDetail } from '@/api/platform'

// interface MEDAY_ITEM {
//   id: number,
//   icon: string,
//   name: string
// }

@Component({
  name: 'Platform'
})

export default class Platform extends Vue {
  private defaultImg = 'http://qnimg.zowoyoo.com/img/84826/1710137356344.png';
  private keyword = ''; // 搜索关键字
  private dataList = [] as Array<any> // 平台列表
  private loading = true // 设置为true是为了先展示骨架屏
  private showPoster = false // 设置为true是为了先展示骨架屏

  private exData = {
    name: '' as string,
    icon: '' as string,
    imgList: [] as Array<any>
  }

  // 分页
  private page = 1
  private resultNum = 4
  private sizeAll = 0
  // page 改变时会触发
  private currentChange (e: number): void {
    this.page = e
    this.dataList = []
    this.handleList()
  }

  // 平台列表
  handleList () {
    this.loading = true
    const params = {
      autoCount: true,
      page: this.page,
      resultNum: this.resultNum,
      name: this.keyword
    }
    getPlatforms(params)
      .then(res => {
        this.loading = false
        this.sizeAll = res.sizeAll
        const results = res.results
        // 处理平台渠道
        const size = 4
        results.forEach(item => {
          item.mediaVoListNew = []
          const num = Math.ceil(item.mediaVoList.length / size)
          for (let i = 0; i < num; i++) {
            const arr = item.mediaVoList.slice(i * size, i * size + size)
            item.mediaVoListNew.push(arr)
          }
        })
        this.dataList = results
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleSearch () {
    this.page = 0
    this.dataList = []
    this.handleList()
  }

  handleMedia (item, n) {
    getMediaDetail({
      mediaId: n.id,
      platId: item.id
    })
      .then(res => {
        if (res.length > 0) {
          const ojb = {
            name: n.name + '平台展示',
            icon: n.icon,
            imgList: res
          }
          this.handlePoster(ojb)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  handlePoster (item) {
    // item = {
    //   name: '平台展示',
    //   icon: 'http://qnimg.zowoyoo.com/img/84826/1710137356344.png',
    //   imgList: [
    //     'http://qnimg.zowoyoo.com/img/84826/1710137356344.png',
    //     'http://qnimg.zowoyoo.com/img/84826/1710137356344.png',
    //     'http://qnimg.zowoyoo.com/img/84826/1710137356344.png',
    //     'http://qnimg.zowoyoo.com/img/84826/1710137356344.png',
    //     'http://qnimg.zowoyoo.com/img/84826/1710137356344.png'
    //   ]
    // }
    // item.imgList
    const arr = [] as any[]
    const num = Math.ceil(item.imgList.length / 4)
    for (let i = 0; i < num; i++) {
      const img = item.imgList.slice(i * 4, i * 4 + 4)
      if (img.length > 0) {
        arr.push(img)
      }
    }
    this.exData.name = item.name
    this.exData.icon = item.icon
    this.exData.imgList = arr
    this.showPoster = true
  }

  goList (item) {
    const { id, custId, menuLink, menuLinkType } = item
    // 如果是外部链接(menuLinkType !== 0)，直接新窗口打开
    if (menuLinkType !== 0 && menuLink) {
      window.open(menuLink, '_blank')
      return
    }
    // 只有custId为空 menuLink有值才跳转
    if ((!custId || custId === '0') && menuLink) {
      this.$router.push(menuLink)
      return
    }
    const queryParams = new URLSearchParams({
      platId: id,
      agentId: custId
    })
    const url = `/platformIndex?${queryParams.toString()}`
    this.$router.push(url)
  }

  mounted () {
    this.handleList()
  }
}
